module.exports = (__webpack_require__(14))(123);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/script-loader/index.js!./node_modules/classlist.js/classlist.min.js from dll-reference obpa_dependencies
// module id = 406
// module chunks = 0